import { MutationTree } from 'vuex';
import { SuiviFacturesPayeesState } from '.';
import { SUIVI_FACTURES_PAYEES } from './mutation-types';
import { SortType } from '@/models/SortType';
import { SuiviFacture } from '@/models/SuiviFacture';

export const mutations: MutationTree<SuiviFacturesPayeesState> = {

    [SUIVI_FACTURES_PAYEES.SET_SCROLL](state, scroll: number) {
        state.scroll = scroll;
    },

    [SUIVI_FACTURES_PAYEES.SET_ITEMS_PAYEES](state, items: SuiviFacture[]) {
        state.facturesPayees = items;
    },
    [SUIVI_FACTURES_PAYEES.ADD_ITEMS](state, items: SuiviFacture[]) {
        state.facturesPayees = [...state.facturesPayees, ...items];
    },
    [SUIVI_FACTURES_PAYEES.SET_PAGE_PAYEES](state, page: number) {
        state.page = page;
    },
    [SUIVI_FACTURES_PAYEES.SET_NB_OF_PAGES_PAYEES](state, pages: number) {
        state.nbOfPages = pages;
    },
    [SUIVI_FACTURES_PAYEES.SET_COUNT_PAYEES](state, count: number) {
        state.count = count;
    },
    [SUIVI_FACTURES_PAYEES.SET_SORT_PAYEES](
        state,
        sort:
            | {
                  sortData: string;
                  sortType: SortType;
              }
            | undefined
    ) {
        state.sort = sort;
    },
    [SUIVI_FACTURES_PAYEES.SET_IS_LOADING_PAYEES](state, isLoading: boolean) {
        state.isLoading = isLoading;
    },
    [SUIVI_FACTURES_PAYEES.SET_ERROR_PAYEES](state, error: Error | undefined) {
        state.error = error;
    },

    [SUIVI_FACTURES_PAYEES.RESET_ITEMS](state) {
        state.facturesPayees = [];
    },

};
